// src/routes.ts

// pages
import Home from "../Pages/Home";

// other
// import MainLayout from "../pages/Layout/MainLayoutContainer";
// import SignupPage from "../pages/Authentication/SignupPage";
// import LoginPage from "../pages/Authentication/LoginPage";
// import PlantSelectionPage from "../pages/PlantSelectionPage/PlantSelectionPage";
import MainLayoutContainer from "../Pages/Layout/MainLayoutContainer";
import SignupPage from "../Pages/Common/Authentication/SignupPage";
import LoginPage from "../Pages/Common/Authentication/LoginPage";
import InputFormContainer from "../Pages/HomePage/InputFormContainer";
import PlantSelectionPage from "../Pages/PlantSelectionPage/PlantSelectionPage";
import Output from "../Pages/Output/Output";
import Experiment from "../Pages/Experiment/Experiment";
import LoadingScreen from "../Pages/Loading/Loading";
import ShareableChart from "../Pages/Chart/ShareableChart";
import Insights from "../Pages/Insights/Insights";
import UserManagementDashboard from "../Pages/UserManagement/UserManagementDashboard";
import HomePage from "../Pages/HomePage/HomePage";
// import ApprovalUDPage from "../Pages/Planner/ApprovalAndUD/ApprovalUDPage";
import MasterSheet2 from "../Pages/MasterSheet/MasterSheet_2";
import AnalystHome from "../Pages/Analyst/AnalystHome";
import ErrorGeneratingSchedule from "../Pages/Common/Error/ErrorGeneratingSchedule";
import ProductionPlannerHome from "../Pages/ProductionPlanner/ProductionPlannerHome";
import SampleCollectorHome from "../Pages/SampleCollector/SampleCollectorHome";
import SampleReceiverHome from "../Pages/SampleReceiver/SampleReceiverHome";
import ReviewerHome from "../Pages/Reviewer/ReviewerHome";
import UdHome from "../Pages/UD/UdHome";
import ApproverHome from "../Pages/Approver/ApproverHome";
import UserGuide from "../Pages/UserGuide/UserGuide";
import ForgotPasswordPage from "../Pages/Common/Authentication/ForgotPasswordPage";
import ResetPasswordPage from "../Pages/Common/Authentication/ResetPasswordPage";

export const routes = [
  {
    key: "home-route",
    title: "Home",
    path: "/",
    protected: true,
    enabled: true,
    role: ["planner"],
    component: MainLayoutContainer,
    Routes: [
      {
        key: "loading",
        title: "Loading Screen",
        component: LoadingScreen,
        path: "loading",
        enabled: true,
      },
      {
        key: "input",
        title: "Upload Files",
        component: HomePage,
        path: "",
        enabled: true,
      },
      {
        key: "input",
        title: "Upload Files",
        component: InputFormContainer,
        path: "input",
        enabled: true,
      },
      {
        key: "input",
        title: "Upload Files",
        component: InputFormContainer,
        path: "input/:section",
        enabled: true,
      },
      {
        key: "input",
        title: "Upload Files",
        component: InputFormContainer,
        path: "input/:section/:tab",
        enabled: true,
      },
      {
        key: "output",
        title: "Generated Schedule",
        component: Output,
        path: "output",
        enabled: true,
      },
      {
        key: "experiment",
        title: "Experiment With Output",
        component: Experiment,
        path: "experiment",
        enabled: true,
      },
      {
        key: "latest-schedule",
        title: "Latest Schedule",
        component: Home,
        path: "latest-schedule",
        enabled: true,
      },
      {
        key: "history",
        title: "History",
        component: Home,
        path: "history",
        enabled: true,
      },
      // {
      //   key: "admin",
      //   title: "Admin Panel",
      //   component: UserManagementDashboard,
      //   path: "admin-panel",
      //   enabled: false,
      // },
      {
        key: "insights",
        title: "Insights",
        component: Insights,
        path: "insights",
        enabled: true,
      },
      // {
      //     key: 'approval_ud',
      //     title: "Approval & UD",
      //     component: ApprovalUDPage,
      //     path: "approval_ud",
      //     enabled: true,
      // },
      {
        key: "alerts",
        title: "Alerts & Updates",
        component: Home,
        path: "alerts",
        enabled: true,
      },
      {
        key: "master-sheet",
        title: "Master Sheet",
        component: MasterSheet2,
        path: "master-sheet",
        enabled: true,
      },
    ],
  },
  {
    key: "home-route",
    title: "Admin",
    path: "/",
    protected: true,
    enabled: true,
    role: ["admin"],
    component: MainLayoutContainer,
    Routes: [
      {
        key: "admin panel",
        title: "Admin Panel",
        component: UserManagementDashboard,
        path: "",
        enabled: true,
      },
      {
        key: "loading",
        title: "Loading Screen",
        component: LoadingScreen,
        path: "loading",
        enabled: true,
      },
      {
        key: "output",
        title: "Generated Schedule",
        component: Output,
        path: "output",
        enabled: true,
      },
      {
        key: "latest-schedule",
        title: "Latest Schedule",
        component: Home,
        path: "latest-schedule",
        enabled: true,
      },
      {
        key: "history",
        title: "History",
        component: Home,
        path: "history",
        enabled: true,
      },
      {
        key: "admin",
        title: "Admin Panel",
        component: UserManagementDashboard,
        path: "admin-panel",
        enabled: true,
      },
      {
        key: "insights",
        title: "Insights",
        component: Insights,
        path: "insights",
        enabled: true,
      },
      // {
      //     key: 'approval_ud',
      //     title: "Approval & UD",
      //     component: ApprovalUDPage,
      //     path: "approval_ud",
      //     enabled: true,
      // },
      {
        key: "alerts",
        title: "Alerts & Updates",
        component: Home,
        path: "alerts",
        enabled: true,
      },
      {
        key: "master-sheet",
        title: "Master Sheet",
        component: MasterSheet2,
        path: "master-sheet",
        enabled: true,
      },
    ],
  },
  {
    key: "chart",
    title: "Shared Chart",
    component: ShareableChart,
    path: "/chart/:view/:id",
    enabled: true,
    role: ["planner"],
  },
  {
    key: "login-route",
    title: "Login",
    path: "/login",
    enabled: true,
    role: "all",
    component: LoginPage,
  },
  {
    key: "signup-route",
    title: "Sign Up",
    path: "/signup",
    enabled: true,
    role: "all",
    component: SignupPage,
  },
  {
    key: "select-plant",
    title: "Select Plant",
    path: "/select-plant",
    protected: true,
    enabled: true,
    role: "all",
    component: PlantSelectionPage,
  },
  {
    key: "all-home",
    title: "all Home",
    path: "/",
    protected: true,
    enabled: true,
    role: "all",
    component: PlantSelectionPage,
  },
  {
    key: "all-error",
    title: "all error",
    path: "/error-while-generating-schedule",
    protected: true,
    enabled: true,
    role: "all",
    component: ErrorGeneratingSchedule,
  },
  {
    key: "analyst-home",
    title: "Analyst Home",
    path: "/",
    protected: true,
    enabled: true,
    role: ["analyst"],
    component: AnalystHome,
  },
  {
    key: "production-planner",
    title: "Production Planner",
    path: "/",
    protected: true,
    enabled: true,
    role: ["production_team"],
    component: ProductionPlannerHome,
  },
  {
    key: "sample-collector",
    title: "Sample Collector",
    path: "/",
    protected: true,
    enabled: true,
    role: ["sample_collector"],
    component: SampleCollectorHome,
  },
  {
    key: "sample-receiver",
    title: "Sample Receiver",
    path: "/",
    protected: true,
    enabled: true,
    role: ["sample_receiver"],
    component: SampleReceiverHome,
  },
  {
    key: "reviewer",
    title: "Reviewer",
    path: "/",
    protected: true,
    enabled: true,
    role: ["reviewer"],
    component: ReviewerHome,
  },
  {
    key: "approver",
    title: "Approver",
    path: "/",
    protected: true,
    enabled: true,
    role: ["approver"],
    component: ApproverHome,
  },
  {
    key: "ud",
    title: "UD",
    path: "/",
    protected: true,
    enabled: true,
    role: ["ud"],
    component: UdHome,
  },
  {
    key: "user-guide",
    title: "User Guide",
    path: "/user-guide",
    protected: true,
    enabled: true,
    role: "all",
    component: UserGuide,
  },
  {
    key: "forgot-password",
    title: "Forgot Password",
    path: "/forgot-password",
    enabled: true,
    role: "all",
    component: ForgotPasswordPage
  },
  {
    key: "reset-password",
    title: "Reset Password",
    path: "/reset-password/:reset_password_token",
    enabled: true,
    role: "all",
    component: ResetPasswordPage
  },
];
